<template>
  <div class="login-container flx-center">
    <div class="login-box">
      <div class="login-left">
        <img class="login-left-img" src="@/assets/images/login_left.png" alt="login" />
      </div>
      <div class="login-form">
        <div class="login-logo">
          <img class="login-icon" src="@/assets/images/qs-logo.png" alt="logo" />
          <h2 class="logo-text">前视检测管理平台</h2>
        </div>

        <el-form :model="loginForm" ref="loginForm" :rules="rules" label-width="0" size="large" :inline="false">
          <el-form-item label="" prop="userName">
            <el-input v-model.trim="loginForm.userName" placeholder="请输入登录账号" name="username" autocomplete clearable>
              <svg-icon slot="prefix" icon-class="icon_login_user" />
            </el-input>
          </el-form-item>
          <el-form-item label="" prop="password">
            <el-input
              type="password"
              v-model="loginForm.password"
              show-password
              name="password"
              placeholder="请输入登录密码"
              clearable
            >
              <svg-icon slot="prefix" icon-class="icon_login_password" />
            </el-input>
          </el-form-item>

          <div class="login-btn">
            <el-checkbox v-model="rememberMe">记住密码</el-checkbox>
            <el-button class="submit-button" :loading="submitLoading" type="primary" size="default" @click="handleLogin">
              登录
            </el-button>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { resetRouter } from '@/router/resetRouter';
import { getRememberAccount, setRememberAccount, removeRememberAccount } from '@/utils/auth';

export default {
  data() {
    return {
      loginForm: {
        userName: '',
        password: ''
      },
      rules: {
        userName: [
          {
            required: true,
            message: '请输入登录用户',
            trigger: 'blur'
          }
        ],
        password: [
          {
            required: true,
            message: '请输入密码',
            trigger: 'blur'
          }
        ]
      },
      rememberMe: false,
      submitLoading: false
    };
  },
  computed: {},
  watch: {},
  methods: {
    handleLogin() {
      this.$refs.loginForm.validate(async valid => {
        if (valid) {
          this.submitLoading = true;

          try {
            await this.$store.dispatch('user/login', this.loginForm);

            resetRouter(); // 更新路由

            // 记住账号
            const cookieAccount = getRememberAccount();
            if (this.rememberMe) {
              const { userName, password } = this.loginForm;
              if (
                !cookieAccount ||
                JSON.parse(cookieAccount).userName !== userName ||
                JSON.parse(cookieAccount).password !== password
              )
                setRememberAccount(JSON.stringify(this.loginForm));
            } else {
              if (cookieAccount) removeRememberAccount();
            }

            this.$router.push('/');
          } finally {
            this.submitLoading = false;
          }
        }
      });
    }
  },
  created() {
    const cookieAccount = getRememberAccount();
    if (cookieAccount) {
      this.loginForm = JSON.parse(cookieAccount);
      this.rememberMe = true;
    }
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>
.login-container {
  height: 100%;
  min-height: 550px;
  background-color: #eeeeee;
  background-image: url('~@/assets/images/login_bg.svg');
  background-repeat: no-repeat;
  background-position: bottom center;
  background-size: 100% auto;
  .login-box {
    position: relative;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-around;
    width: 96.5%;
    height: 94%;
    padding: 0 50px;
    background-color: rgb(255 255 255 / 80%);
    border-radius: 10px;
    .dark {
      position: absolute;
      top: 13px;
      right: 18px;
    }
    .login-left {
      width: 800px;
      margin-right: 10px;
      .login-left-img {
        width: 100%;
        height: 100%;
      }
    }
    .login-form {
      width: 420px;
      padding: 50px 40px 45px;
      background-color: var(--el-bg-color);
      border-radius: 10px;
      box-shadow: rgb(0 0 0 / 10%) 0 2px 10px 2px;
      .login-logo {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 45px;
        .login-icon {
          width: 42px;
          height: 42px;
        }
        .logo-text {
          margin: 0;
          font-size: 38px;
          font-weight: bold;
          color: #34495e;
          white-space: nowrap;
        }
      }
      .el-form-item {
        margin-bottom: 40px;
      }
      .login-btn {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        margin-top: 40px;
        white-space: nowrap;
        .el-button {
          width: 185px;
        }
      }
    }
  }
}

@media screen and (max-width: 1250px) {
  .login-left {
    display: none;
  }
}

@media screen and (max-width: 600px) {
  .login-form {
    width: 97% !important;
  }
}
</style>
